module.exports = __webpack_public_path__ + "static/headshot-henry-stamerjohan-3x.33143994.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/headshot-henry-stamerjohan-3x.jpg
// module id = 523
// module chunks = 152909308826437